import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { CLAN_LANDING } from 'urls'

import ClanManagementContainer from './containers/ClanManagement'

import { Processing } from 'react-wot-bootstrap'
import DialogWrapper from './components/Dialogs'
import UpdateMembersStatusesManager from './components/UpdateMembersStatusesManager'
import { playExitMainCardSound } from 'state/actions/sounds'

import styles from './ClanManagement.scss'

const BACKSPACE_KEYCODE = 8
const TAB_KEYCODE = 9

export class ClanManagement extends React.Component {
    static propTypes = {
        dialog: PropTypes.node,
        fetchingText: PropTypes.string,
        fetchingVisible: PropTypes.bool,

        openClanLanding: PropTypes.func.isRequired,
        playExitMainCardSound: PropTypes.func.isRequired,
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDown, true)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown, true)
    }

    onKeyDown(e) {
        if (e.keyCode === TAB_KEYCODE || (e.target.tagName !== 'INPUT' && e.keyCode === BACKSPACE_KEYCODE))
            e.preventDefault()
    }

    handleBackClick = () => {
        this.props.openClanLanding()
        this.props.playExitMainCardSound()
    }

    render() {
        return (
            <div className={styles.base}>
                <ClanManagementContainer onBackClick={this.handleBackClick} />
                <Processing type="window" caption={this.props.fetchingText} isVisible={this.props.fetchingVisible} />
                <DialogWrapper dialog={this.props.dialog} />
                <UpdateMembersStatusesManager />
            </div>
        )
    }
}

export const mapStateToProps = state => {
    const { fetching, dialog } = state

    return {
        fetchingText: fetching.text,
        fetchingVisible: fetching.counter > 0,
        dialog: dialog.dialog,
    }
}

export const mapDispatchToProps = {
    openClanLanding: () => push(CLAN_LANDING),
    playExitMainCardSound,
}

export default connect(mapStateToProps, mapDispatchToProps)(ClanManagement)



// WEBPACK FOOTER //
// ./containers/ClanManagement/ClanManagement.jsx